import React from 'react'
import { SmallFireIcon, ShieldSmallIcon, YellowFireIcon } from '@shared/assets/icons'

export const profitableOfferBadge = {
  color: 'popular_20',
  title: 'Выгодное предложение',
  icon: <SmallFireIcon />,
}

export const officialPartnerBadge = {
  color: 'official_20',
  title: 'Официальный партнер',
  icon: <ShieldSmallIcon />,
}

export const newServiceBadge = {
  color: 'new_20',
  title: 'Новинка',
  icon: <YellowFireIcon />,
}
